import {
  Box,
  Container,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { pink } from "@mui/material/colors";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-hot-toast";
import Title from "../../../../components/title";
import { LoadingTable } from "../../../../components/Loading/LoadingTable";
import { NoData } from "../../../../components/NoData/NoData";
import { StyledTableCell } from "../../../franchise/components/StyledTableCell";
import paginaLinksService from "../../../../services/paginaLinks";
import { PermissionsPage } from "../../../../util/permissionsPage";

export const PaginaLinksList = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async () => {
    setIsLoading(true);
    try {
      const response = await paginaLinksService.listar();
      setData(response.data);
    } catch (error) {
      toast.error("Erro ao buscar páginas");
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id, slug) => {
    if (!window.confirm(`Deseja excluir a página "${slug}"?`)) return;
    try {
      await paginaLinksService.deletar(id);
      toast.success("Página excluída com sucesso");
      getData();
    } catch (error) {
      toast.error("Erro ao excluir página");
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {PermissionsPage("paginaLinks") && (
        <>
          <Container className="containerFlexBox">
            <Title title="PÁGINAS DE LINKS" />
          </Container>

          <Box
            component={Container}
            marginY={2}
            display="flex"
            justifyContent="flex-end"
          >
            <Tooltip title="Cadastrar nova página">
              <IconButton
                size="small"
                sx={{ color: pink[400] }}
                onClick={() => history.push("/links/paginas/criar")}
              >
                <AddBoxIcon sx={{ width: 50, height: 50 }} />
              </IconButton>
            </Tooltip>
          </Box>

          {isLoading ? (
            <LoadingTable />
          ) : (
            <Container sx={{ paddingBottom: "2rem" }}>
              {data.length === 0 ? (
                <Box width="100%" display="flex" justifyContent="center" alignItems="center">
                  <NoData />
                </Box>
              ) : (
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Nome</StyledTableCell>
                          <StyledTableCell>Slug</StyledTableCell>
                          <StyledTableCell>Ações</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map((row) => (
                          <TableRow key={row.id} hover>
                            <TableCell sx={{ maxWidth: 300 }}>
                              {row.name}
                            </TableCell>
                            <TableCell>
                              <code style={{ fontSize: 12 }}>{row.slug}</code>
                            </TableCell>
                            <TableCell>
                              <Tooltip title="Editar">
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    history.push(`/links/paginas/editar/${row.id}`)
                                  }
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Excluir">
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => handleDelete(row.id, row.slug)}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              )}
            </Container>
          )}
        </>
      )}
    </>
  );
};
